import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEyeSlash, faEye, faCircleInfo, faX } from '@fortawesome/free-solid-svg-icons';
import { useParams } from 'react-router';
import { useNavigate } from 'react-router-dom';
import html2pdf from 'html2pdf.js';
import { Col } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { Form } from 'react-bootstrap';
import { selectFerpaState, setFerpaState } from '../../../../../features/authentication/authSlice';
import { useSelector } from 'react-redux';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import HesSpinner from '../../../../../components/loadingOverlay/hesSpinner';
import { useAssignmentResponseMutation } from '../../../../../features/authentication/assignmentApislice';
import { useOverrideResponseMutation } from '../../../../../features/authentication/assignmentApislice';
import { useShowIdentificationFieldsMutation } from '../../../../../features/authentication/assignApiSlice';
import { useGetFerpaStatusMutation } from '../../../../../features/authentication/assignApiSlice';
import CustomToast from '../../../../../components/Toast';
import { DateFormatter } from '../../../../../utils/DateFormatter';

const Responses = () => {
  const { assignmentId, studentId } = useParams();
  const [assignmentResponse] = useAssignmentResponseMutation();
  const [getFerpaStatus] = useGetFerpaStatusMutation();
  const [overrideResponse] = useOverrideResponseMutation();
  const [showIdentificationFields] = useShowIdentificationFieldsMutation();
  const [assignmentResponseData, setAssignmentResponseData] = React.useState();
  const [hideName, setHideName] = React.useState(false);
  const [selectedQuestionId, setSelectedQuestionId] = React.useState();
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = React.useState(false);
  const [ferpaEnabled, setFerpaEnabled] = React.useState(useSelector(selectFerpaState));
  const [showFerpa, setShowFerpa] = React.useState(false);
  const [loader, setLoader] = React.useState(false);
  const [selectedIndex, setSelectedIndex] = React.useState();
  const dispatch = useDispatch();

  React.useEffect(() => {
    fetchAssignmentResponse();
  }, []);

  React.useEffect(() => {
    fetchStudentName();
  }, [studentId]);

  const handleFerpaChange = async (e) => {
    setFerpaEnabled(!ferpaEnabled);
    dispatch(
      setFerpaState({
        ferpaEnabled: e.target.checked
      })
    );
    const data = {
      condition: e.target.checked
    };
    try {
      await showIdentificationFields(data).unwrap();
      await fetchStudentName();
    } catch (error) {
      console.log(error);
    }
  };

  const toggleHideName = async () => {
    const data = {
      condition: hideName
    };
    try {
      await showIdentificationFields(data).unwrap();
      await fetchStudentName();
    } catch (error) {
      console.log(error);
    }
  };

  const fetchStudentName = async () => {
    const data = {
      studentId: studentId
    };
    const response = await getFerpaStatus(data).unwrap();
    if (!response.showIdentificationFields) {
      setHideName(true);
      setFerpaEnabled(false);
    } else {
      setFerpaEnabled(true);
      setHideName(false);
    }
  };

  const fetchAssignmentResponse = async () => {
    const data = {
      assignmentId: assignmentId,
      studentId: studentId
    };
    try {
      const response = await assignmentResponse(data).unwrap();
      setAssignmentResponseData(response);
    } catch (error) {
      if (error.originalStatus === 400) {
        navigate(-1);
        CustomToast(error.data, 'error');
      }
    }
  };

  const handlePrint = async () => {
    // Generate the PDF from the HTML content
    setShowFerpa(false);
    const contentWrapper = document.getElementById('pdf_Wrapper');
    const tables = document.getElementsByTagName('table');
    const pTag = document.getElementsByTagName('p');
    const studentName = document.getElementById('student-name');
    const printButton = document.getElementById('print_button');
    const ferpaButton = document.getElementById('ferpa-button');
    const backButton = document.getElementById('back_button');

    printButton.style.display = 'none';
    ferpaButton.style.display = 'none';
    backButton.style.display = 'none';
    studentName.style.display = 'none';

    // Apply CSS styles to tables
    for (let i = 0; i < tables.length; i++) {
      const table = tables[i];
      table.style.pageBreakInside = 'avoid';
      table.style.breakInside = 'avoid';
      table.style.keepWithWindow = 'always';
    }

    // Apply CSS styles to p tag
    for (let i = 0; i < pTag.length; i++) {
      const p = pTag[i];
      p.style.pageBreakInside = 'avoid';
      p.style.breakInside = 'avoid';
      p.style.keepWithWindow = 'always';
    }

    // Apply CSS styles to div

    const options = {
      margin: 60, // Specify the margin for all sides (top, right, bottom, left)
      image: { type: 'jpeg', quality: 0.98 }, // Set the image type and quality (optional)
      html2canvas: { scale: 2 }, // Set the scale for better quality (optional)
      jsPDF: { unit: 'pt', format: 'a3', orientation: 'portrait' }, // Set the document format and orientation (optional)
      pagebreak: {
        mode: ['avoid-all', 'css', 'legacy']
      }
    };

    await html2pdf().set(options).from(contentWrapper).save('Responses.pdf');
    ferpaButton.style.display = 'block';
    backButton.style.display = 'block';
    printButton.style.display = 'block';
    studentName.style.display = 'inline';
  };

  const handleRadioChange = (choice, question, index) => {
    setSelectedIndex(index);
    setLoader(true);
    const updatedQuestion = {
      ...question,
      studentResponse: {
        ...question.studentResponse,
        response: choice,
        teacherOverride:
          choice === 'Choice 0' ? 0 : choice === 'Choice 1' ? 1 : choice === 'Choice 2' ? 2 : null
      }
    };

    // Update the state with the updated question
    setAssignmentResponseData((prevData) => {
      const updatedQuestions = prevData.questions.map((q) => {
        if (q.questionOrder === updatedQuestion.questionOrder) {
          return updatedQuestion;
        }
        return q;
      });

      return { ...prevData, questions: updatedQuestions };
    });

    // Update the API response
    const data = {
      assignmentId: assignmentId,
      questionIndex: index + 1,
      sudentId: studentId,
      option:
        choice === 'Choice 0' ? 0 : choice === 'Choice 1' ? 1 : choice === 'Choice 2' ? 2 : null
    };

    overrideResponse(data)
      .then((response) => {
        // Update the state with the API response

        setAssignmentResponseData((prevData) => {
          const updatedQuestions = prevData.questions?.map((q) => {
            if (q.questionOrder === updatedQuestion?.questionOrder) {
              return {
                ...q,
                studentResponse: {
                  ...q.studentResponse,
                  response: response.data?.response,
                  retryResponse: response.data?.retryResponse,
                  status: response.data?.status
                  // Access the specific property of the response object
                }
              };
            }
            return q;
          });

          return { ...prevData, questions: updatedQuestions };
        });
        setLoader(false);
        setSelectedIndex(null);
      })
      .catch((error) => {
        // Handle the error if the Promise is rejected
        console.error('Error updating API response:', error);
      });
  };

  const handleToggle = (index) => {
    setIsExpanded(index == selectedQuestionId ? !isExpanded : true);
    setSelectedQuestionId(index);
  };

  return assignmentResponseData ? (
    <div className="content-wrapper" id="pdf_Wrapper">
      <div className="white-card assignment-response-header mb-4">
        <div className='d-flex flex-row justify-content-between'>
          <h3>Responses Report</h3>
          <div className="d-flex justify-content-end mb-4 gap-3 button-wrapper">
            <button
              onClick={() => setShowFerpa(!showFerpa)}
              className="btn-link primary-link"
              id="ferpa-button">
              <FontAwesomeIcon icon={faCircleInfo} /> FERPA
            </button>
            <button onClick={handlePrint} id="print_button" className="btn btn-width btn-castleRed">
              Print to PDF
            </button>
            <button className="btn btn-width btn-castleWhite" id="back_button" onClick={() => navigate(-1)}>
              Back
            </button>

            {showFerpa && (
              <div id="ferpaMessages" className="d-flex flex-row ferpaMessage">
                <div className="d-flex flex-column">
                  <p>
                    Student identification information should not be printed or displayed publicly or
                    emailed as per FERPA requirements.
                  </p>
                  <a
                    href="https://www2.ed.gov/policy/gen/guid/fpco/ferpa/index.html"
                    target="_blank"
                    rel="noreferrer"
                    className="link-orange"
                    style={{ marginBottom: '16px' }}>
                    Family Educational Rights and Privacy Act (FERPA)
                  </a>
                  <Form.Check
                    type="checkbox"
                    id="displayStudentNames"
                    className="d-flex flex-row align-items-center">
                    <Form.Check.Input
                      type="checkbox"
                      defaultChecked={ferpaEnabled}
                      style={{ marginRight: '5px' }}
                      onClick={(e) => handleFerpaChange(e)}
                    />
                    <Form.Check.Label>Display Student Names/Identification</Form.Check.Label>
                  </Form.Check>
                </div>
                <FontAwesomeIcon
                  color="#525252"
                  style={{ fontSize: '20px', cursor: 'pointer' }}
                  icon={faX}
                  onClick={() => setShowFerpa(false)}
                />
              </div>
            )}
          </div>
        </div>

        <div className="row">
          <div className="col-lg-4 d-flex flex-wrap flex-column flex-sm-row flex-lg-column justify-content-between justify-content-lg-start gap-1 mb-2 mb-lg-0 text-center text-sm-start">
            <p>
              Student:{' '}
              {hideName ? (
                <strong>name hidden</strong>
              ) : (
                <strong>{assignmentResponseData.student}</strong>
              )}
              <button
                id="student-name"
                className="btn-link primary-link ms-2 "
                onClick={toggleHideName}>
                <FontAwesomeIcon icon={hideName ? faEye : faEyeSlash} />{' '}
                {hideName ? 'Show Name' : 'Hide Name'}
              </button>
            </p>
            <p>
              Description:<strong> {assignmentResponseData.description}</strong>
            </p>
          </div>
          <div className="col-lg-4 text-center d-flex flex-wrap flex-column flex-sm-row flex-lg-column justify-content-between justify-content-lg-start gap-1 mb-2 mb-lg-0">
            <p>
              Date Assigned:<strong> {assignmentResponseData.dateAssigned.replace(/\//g, '-')}</strong>
            </p>
            <p>
              Date Completed:<strong> {assignmentResponseData.dateCompleted.replace(/\//g, '-')} </strong>
            </p>
          </div>
          <div className="col-lg-4 text-center text-sm-end d-flex flex-wrap flex-column flex-sm-row  flex-lg-column justify-content-between justify-content-lg-start gap-1">
            <p>
              Assignment Mode:<strong> {assignmentResponseData.assignmentMode}</strong>
            </p>
            <p>
              Report Date:<strong> {DateFormatter.toLongDateTime2(assignmentResponseData.reportDate)}</strong>
            </p>
          </div>
        </div>
        <div className="d-flex flex-wrap justify-content-center justify-content-sm-between align-items-center assignment-response-conunt pt-3 mt-3 gap-2 text-center">
          <p>
            Number of questions in the assignment{' '}
            <span>{assignmentResponseData.questionCount}</span>
          </p>
          <div className="d-flex flex-wrap gap-2 justify-content-center">
            <p>
              % Correct{' '}
              <span className="correct">{`${assignmentResponseData.correctAnswerPercentage}%`}</span>
            </p>
            <p>
              Number of correct answers <span>{assignmentResponseData.numberOfCorrectAnswer}</span>
            </p>
          </div>
        </div>
      </div>

      {assignmentResponseData.directions && (
        <div className="white-card">
          <div className="w-100  bg-light p-2">
            <h2 className="fw-bold mb-auto">Direction</h2>
          </div>
          <div dangerouslySetInnerHTML={{ __html: assignmentResponseData.directions }}></div>
        </div>
      )}

      {assignmentResponseData.questionBar && (
        <div className="white-card">
          <div className="w-100  bg-light p-2">
            <h2 className="fw-bold mb-auto">Question</h2>
          </div>
          <div dangerouslySetInnerHTML={{ __html: assignmentResponseData.readingSelections }}></div>
        </div>
      )}

      {assignmentResponseData.readingSelections && (
        <div className="white-card">
          <div className="w-100  bg-light p-2">
            <h2 className="fw-bold mb-auto">Reading Selection</h2>
          </div>
          <div dangerouslySetInnerHTML={{ __html: assignmentResponseData.readingSelections }}></div>
        </div>
      )}

      {assignmentResponseData.questions.map((question, mainIndex) => {
        const decodedHtml = decodeURIComponent(question?.questionEx?.crAnswer);
        return (
          <div className="white-card avoid-split" key={mainIndex}>
            <div className="assignment-response-qa mb-4 pb-2">
              <div className="d-flex">
                <div className='d-flex flex-row gap align-content-center me-2'>
                  <h6 className="flex-shrink-0 me-2">{mainIndex + 1}.</h6>
                  {question.mcAnswer && <span style={{ marginTop: '4px' }}><u>&nbsp;&nbsp;{question.mcAnswer}&nbsp;&nbsp;</u></span>}
                </div>

                <div className='d-flex flex-column'>
                    {question.graphicInfo.map((graphicInfo, index) => {
                      return (
                        <>
                          <div className="d-flex flex-row align-items-center" key={index}>
                            {graphicInfo.type == '.htm' && (
                              <>
                                <span className='d-flex flex-row align-items-center' dangerouslySetInnerHTML={{__html: graphicInfo.selectionTitle}}></span>

                                {graphicInfo.selectionTitle && <button
                                  style={{
                                    background: '#e1eeff',
                                    color: 'rgba(84, 113, 200, 0.6)',
                                    width: '30px',
                                    height: '30px',
                                    textAlign: 'center',
                                    border: 'none',
                                    marginLeft: '10px'
                                  }}
                                  className="rounded-circle"
                                  onClick={() => handleToggle(mainIndex)}>
                                  {isExpanded && selectedQuestionId == mainIndex ? (
                                    <FontAwesomeIcon icon={faChevronUp} />
                                  ) : (
                                    <FontAwesomeIcon icon={faChevronDown} />
                                  )}
                                </button>}
                              </>
                            )}
                            <div></div>
                          </div>
                          {isExpanded && selectedQuestionId == mainIndex &&
                            <div dangerouslySetInnerHTML={{ __html: graphicInfo.description }}></div>
                          }
                        </>
                      );
                    })}
                  <p dangerouslySetInnerHTML={{ __html: question.questionText }}></p>
                  {question.isBlocked && (
                    <p className="text-danger">
                      <strong
                        dangerouslySetInnerHTML={{
                          __html: question.blockedQuestionMessage
                        }}></strong>
                    </p>
                  )}
                </div>
              </div>

              {question.questionEx && (
                <div className="assignment-response-answer avoid-split">
                  <Col className="avoid-split" md={6}>
                    <p>
                      Status: <span className={`${question.questionEx.crStatus == 'Answered' ? 'correct' : question.questionEx.crStatus == 'Not Answered' ? 'incorrect' : 'inprogress'}`}>
                        <strong>{question.questionEx.crStatus}</strong>
                      </span>
                    </p>
                    <p>
                      Answer: <strong dangerouslySetInnerHTML={{ __html: decodedHtml }}></strong>
                    </p>
                    <p>
                      Points: <strong>{question.questionEx.crPoints}</strong>
                    </p>
                  </Col>
                </div>
              )}
              {question.studentResponse.isTeacherOverride ? (
                <div className="assignment-response-answer avoid-split">
                  {loader && selectedIndex === mainIndex ? (
                    <div
                      className="d-flex justify-content-start align-items-center"
                      style={{ height: '40px' }}>
                      <HesSpinner />
                      <span className="ms-3">Loading results...</span>
                    </div>
                  ) : (
                    <div className="d-flex flex-wrap gap-3" id="status-bar2">
                      <p>
                        Status{' '}
                        <span
                          className={
                            question.studentResponse.status === 'Correct on Retry' ||
                              question.studentResponse.status === 'Correct'
                              ? 'correct'
                              : 'incorrect'
                          }>
                          {question.studentResponse.status}
                        </span>
                      </p>
                      {question.studentResponse.response && (
                        <p>
                          Response: <strong>{question.studentResponse.response}</strong>
                        </p>
                      )}
                      {question.studentResponse.retryResponse && (
                        <p>
                          Retry Response:{' '}
                          <strong>{question?.studentResponse?.retryResponse}</strong>
                        </p>
                      )}
                    </div>
                  )}
                  <div id="status-bar1">
                    <div className="d-flex flex-wrap gap-3 align-items-center mt-3">
                      <label className="form-label mb-0 me-2">Teacher Override</label>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name={`flexRadioDefault${mainIndex}`}
                          id="flexRadioDefault3"
                          checked={question.studentResponse.teacherOverride === 0}
                          onClick={() => handleRadioChange('Choice 0', question, mainIndex)}
                        />
                        <label className="form-check-label ms-2" htmlFor="flexRadioDefault3">
                          None
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name={`flexRadioDefault${mainIndex}`}
                          id="flexRadioDefault4"
                          checked={question.studentResponse.teacherOverride === 1}
                          // onChange={() => handleRadioChange('Choice 1', question)}
                          onClick={() => handleRadioChange('Choice 1', question, mainIndex)}
                        />
                        <label className="form-check-label ms-2" htmlFor="flexRadioDefault4">
                          First Answer
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name={`flexRadioDefault${mainIndex}`}
                          id="flexRadioDefault5"
                          checked={question.studentResponse.teacherOverride === 2}
                          // onChange={() => handleRadioChange('Choice 2', question)}
                          onClick={() => handleRadioChange('Choice 2', question, mainIndex)}
                        />
                        <label className="form-check-label ms-2" htmlFor="flexRadioDefault5">
                          Retry Answer
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                !question.isBlocked &&
                !question.questionEx && (
                  <div id="status-bar" className="assignment-response-answer avoid-split">
                    <div className="d-flex flex-wrap gap-3">
                      <p>
                        Status{' '}
                        <span
                          className={
                            (question.questionEx
                              ? question.questionEx?.crStatus
                              : question.studentResponse?.status) === 'Correct on Retry' ||
                              (question.questionEx
                                ? question.questionEx?.crStatus
                                : question.studentResponse?.status) === 'Correct'
                              ? 'correct'
                              : 'incorrect'
                          }>
                          <strong>
                            {question.questionEx
                              ? question.questionEx?.crStatus
                              : question.studentResponse?.status}
                          </strong>
                        </span>

                        {question.studentResponse.response && (
                          <p>
                            Response: <strong>{question.studentResponse.response}</strong>
                          </p>
                        )}
                        {question.studentResponse.retryResponse && (
                          <p>
                            Retry Response:{' '}
                            <strong>{question?.studentResponse?.retryResponse}</strong>
                          </p>
                        )}
                      </p>
                    </div>
                  </div>
                )
              )}
            </div>
          </div>
        );
      })}
    </div>
  ) : (
    <div className="d-flex justify-content-center align-items-center" style={{ height: '40px' }}>
      <HesSpinner />
      <span className="ms-3">Loading results...</span>
    </div>
  );
};

export default Responses;
